/**
 * 进度条歌词 Hint：独立 portal 到 body，避免被播放器裁剪
 * 抽离自 MusicPlayer.js
 */
import React from 'react';
import { createPortal } from 'react-dom';

/**
 * @param {object} refs - seekPreviewRef, seekPreviewTimeRef, seekPreviewTextRef, seekPreviewTransRef
 */
export default function SeekPreviewPortal({ refs }) {
  const { seekPreviewRef, seekPreviewTimeRef, seekPreviewTextRef, seekPreviewTransRef } = refs || {};
  if (typeof document === 'undefined') return null;
  return createPortal(
    <div
      ref={seekPreviewRef}
      data-seek-preview
      aria-hidden="true"
      className="relative pointer-events-none select-none px-2.5 py-2 rounded-xl border border-amber-400/30 bg-gray-900/90 backdrop-blur-md shadow-[0_18px_42px_rgba(0,0,0,0.55)] w-[min(320px,80vw)] max-w-[360px]"
      style={{
        position: 'fixed',
        left: '50%',
        top: '0px',
        zIndex: 100000,
        opacity: 0,
        transform: 'translateX(-50%) translateY(-100%) translateY(-8px) scale(0.98)'
      }}
    >
      <div className="flex items-center gap-2">
        <span
          ref={seekPreviewTimeRef}
          data-seek-preview-time
          className="text-[11px] tabular-nums px-2 py-0.5 rounded-lg border border-amber-400/25 bg-amber-500/10 text-amber-100"
        >
          0:00
        </span>
      </div>
      <div
        ref={seekPreviewTextRef}
        data-seek-preview-text
        className="mt-1 text-[12px] leading-snug text-white whitespace-nowrap overflow-hidden"
        style={{ maxWidth: '100%' }}
      >
        &nbsp;
      </div>
      <div
        ref={seekPreviewTransRef}
        data-seek-preview-trans
        className="mt-0.5 text-[11px] leading-snug text-white/70 whitespace-nowrap overflow-hidden"
        style={{ display: 'none', maxWidth: '100%' }}
      >
        &nbsp;
      </div>

      <div
        data-seek-preview-arrow
        aria-hidden="true"
        style={{
          position: 'absolute',
          left: '50%',
          bottom: '-8px',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderTop: '8px solid rgba(17,24,39,0.90)'
        }}
      />
    </div>,
    document.body
  );
}
